import {FlowModule, UIDisableReason, IEventManagerWithAsync, GlobalEventsMap, LogicEvents} from '@gongxigames/framework/slot';
import {GameFlowBasicState} from 'src/win/states/GameFlowBasicState';
import {GameFlowRestoreState} from 'src/win/states/GameFlowRestoreState';
import {GameFlowFreeSpinsState} from 'src/win/states/GameFlowFreeSpinsState';
import {GameLogic} from 'src/server/GameLogic';
import {Action} from 'com/gongxigames/math/core/game/enums/Action';
import {GamePickBonusEvents} from 'src/pickBonus/GamePickBonusEvents';

export class GameFlowModule extends FlowModule {
    protected setupStates(): void {
        super.setupStates();
        this.addState(new GameFlowBasicState(this, FlowModule.BASIC_STATE));
        this.addState(new GameFlowRestoreState(this, FlowModule.RESTORE_STATE));
        this.addState(new GameFlowFreeSpinsState(this, FlowModule.FREE_SPINS_STATE));
        this.gotoState(FlowModule.BASIC_STATE);
    }

    protected setupEvents(): void {
        super.setupEvents();
        this.onCurrentStateHandle(LogicEvents.BUY_RESPONSE);
        this.onCurrentStateHandle(GamePickBonusEvents.PICK_BONUS_FINISHED);
    }

    protected onAllReelsStopped(): void {
        const logic = (this.logic as GameLogic);

        if ((this.logic.nextAction === Action.FREESPIN && this.logic.previousAction !== Action.FREESPIN &&
                this.logic.previousAction !== Action.RESPIN) ||
            this.logic.isRetriggerWon() || logic.isRandomWildFeature() || logic.nextAction === Action.PICK) {
            (this.eventManager as IEventManagerWithAsync<GlobalEventsMap>).emit('General.UI.DISABLE', UIDisableReason.TRIGGERING_FEATURE);
        }
    }
}
